import { useDeviceStore } from "@/store/deviceStore";
import type { UserDeviceInfo } from "~~/src/models/dto-types";
export default defineNuxtRouteMiddleware((to, from) => {

  const deviceStore = useDeviceStore();
	deviceStore.setDevice();

	const isMobile = deviceStore.deviceInfo?.isMobile;
	

	let deviceInfo: string | UserDeviceInfo= window.localStorage.getItem("userDeviceInfo") as string

	if(deviceInfo === 'undefined' || deviceInfo === 'null' || !deviceInfo) window.localStorage.setItem("userDeviceInfo", JSON.stringify({} as UserDeviceInfo));

	deviceInfo = JSON.parse(window.localStorage.getItem("userDeviceInfo") as string) as UserDeviceInfo;
  
	const IsShowIntro = deviceInfo?.IsShowIntro;
  // console.log(IsShowIntro && to.query.intro !== "false" && window.localStorage.getItem("autoLogin") !== "true");

  const isAutoLoginCheck = ref(window.localStorage.getItem("autoLogin") === 'true' ? 'true' : 'false');


	// const userToken = useCookie("userToken");
	// alert(userToken.value);

	if (isMobile) {
		if(IsShowIntro === true || IsShowIntro === undefined){
			if (to.query.intro !== "false" && isAutoLoginCheck.value !== "true") {
				// if (!from.fullPath.includes("login")) {
				// if (to.query.intro !== "false") {
				return navigateTo("/mobile/user/intro");
			}
		}
	}
});
